import type { SVGProps } from 'react'
const SvgSyFolder = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M7.668 1.525c-1.936 0-3.442.614-4.375 1.786-.933 1.171-1.268 2.771-1.268 4.652v7.795c0 1.936.585 3.58 1.723 4.717s2.784 1.72 4.725 1.72h7.785c1.936 0 3.578-.586 4.715-1.722 1.136-1.136 1.721-2.777 1.722-4.711l.028-4.965v-.004c0-1.916-.34-3.481-1.291-4.596-.952-1.114-2.45-1.63-4.371-1.63h-2.829a1.54 1.54 0 0 1-1.226-.616l-.914-1.213a3.03 3.03 0 0 0-2.424-1.213zm0 1.5h2c.483 0 .935.227 1.225.614h.002l.912 1.215a3.05 3.05 0 0 0 2.424 1.212h2.83c1.666 0 2.623.395 3.23 1.106.607.71.932 1.886.932 3.621l-.028 4.96v.005c0 1.642-.47 2.842-1.283 3.654s-2.012 1.283-3.654 1.283H8.473c-1.647 0-2.851-.47-3.664-1.283S3.525 17.4 3.525 15.758V7.963c0-1.697.323-2.942.942-3.719s1.56-1.219 3.201-1.219"
				clipRule="evenodd"
			/>
			<path
				d="M7.559 13.738a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h9.593a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyFolder
